import MODULES from "./module.constant";

export const getDefaultRedirect = (modules, role) => {

   //  if(modules && Array.isArray(modules) && modules.includes(MODULES.USER_MODULE)){
   //     return '/users/'
   //  }

   //  if(modules && Array.isArray(modules) && modules.includes(MODULES.PRODUCT_MODULE)){
   //      return '/products/'
   //   }
     
   // //  if(modules && Array.isArray(modules) && modules.includes(MODULES.REGION_MODULE)){
   // //    return '/region/'
   // // }

   // if(modules && Array.isArray(modules) && modules.includes(MODULES.CAMP_MODULE)){
   //    return '/camp/'
   // }
   
   // if(modules && Array.isArray(modules) && modules.includes(MODULES.BENEFICIARY_ADD)){
   //    return '/beneficiary/add/'
   // }

   
   // if(modules && Array.isArray(modules) && modules.includes(MODULES.BENEFICIARY_FETCH)){
   //    return '/beneficiary/beneficiary-data'
   // }
   //   if(modules && Array.isArray(modules) && modules.includes(MODULES.BENIFICIARY_TEST)){
   //      return '/beneficiary/beneficiary-list/'
   //   }
   //   if(modules && Array.isArray(modules) && modules.includes(MODULES.BENIFIICIARY_DONATIONS)){
   //      return '/beneficiary/genral-list/'
   //   }
   //   if(modules && Array.isArray(modules) && modules.includes(MODULES.EVENT_MODULE)){
   //      return '/events/'
   //   }
   //   if(modules && Array.isArray(modules) && modules.includes(MODULES.FOLLOWUP_LIST)){
   //      return '/followups/'
   //   }
     return "/dashboard";
}